import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import type { ReactNode } from 'react'

type FormFieldProps = {
  label: string
  hint?: string
  error?: string
  required?: boolean
  children: ReactNode
}

/** Labelled form-control wrapper: bold label, optional hint or error line. */
export default function FormField({ label, hint, error, required, children }: FormFieldProps) {
  const theme = useTheme()
  const c = theme.affexy.colors
  return (
    <Box component="label" sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      <Typography component="span" sx={{ fontSize: 12.5, fontWeight: 700, color: c.ink }}>
        {label}
        {required && <Box component="span" sx={{ color: c.coral, ml: 0.5 }}>*</Box>}
      </Typography>
      {children}
      {error ? (
        <Typography component="span" sx={{ fontSize: 12, color: c.danger }}>
          {error}
        </Typography>
      ) : (
        hint && (
          <Typography component="span" sx={{ fontSize: 12, color: c.ink56 }}>
            {hint}
          </Typography>
        )
      )}
    </Box>
  )
}
